import styled from "styled-components";
import Button from "@8x8/oxygen-button";

export const StyledButtonPill = styled(Button)`
  border-radius: 12px;
`;
